<template>
  <div class="nav-cate-wrapper">
    <div class="navcate-title" :class="{ 'navcate-title__hover': !showCate}" >
      <i class="iconfont icon-shangpinleimu"></i>
      <span>全部应用分类</span>
    </div>
    <div class="navcate-content-wrapper"
      :class="{'navcate-content':showCate}" :style="{borderWidth: showCate ? '0': '1px'}">
      <zcy-cate-item :show-cate="showCate" v-for="(item, index) in cateList" :key="index" v-bind="item"></zcy-cate-item>
    </div>
  </div>
</template>

<script>
import CateItem from './cate-item';
import { getFrontCategory } from '@/services';
function mapCate (category) {
  return Array.prototype.map.call(category, (item) => {
    if (!item.children || !item.children.length) {
      return {
        icon: item.current.logo,
        text: item.current.name,
        id: item.current.id
      };
    } else {
      let child = mapCate(item.children);
      return {
        icon: item.current.logo,
        text: item.current.name,
        id: item.current.id,
        children: child
      };
    }
  });
}
export default {
  components: {
    'zcy-cate-item': CateItem
  },
  props: {
    showCate: {
      type: Boolean,
      default: true
    },
    envHref: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cateList: [
        {
          icon: 'icon-chanpinzhongxin',
          text: '网站建设',
          children: [{
            text: '网站建站'
          }]
        }, {
          icon: 'icon-chanpinzhongxin',
          text: '教育教学',
          children: [{
            text: '教育教学'
          }]
        }, {
          icon: 'icon-chanpinzhongxin',
          text: '医疗卫生',
          children: [{
            text: '医疗卫生'
          }]
        },
        {
          icon: 'icon-chanpinzhongxin',
          text: '数据/报表',
          children: [{
            text: '采购内参'
          }, {
            text: '交互报表'
          }]
        }, {
          icon: 'icon-chanpinzhongxin',
          text: '采购管理',
          children: [{
            text: '车辆控购'
          }]
        }, {
          icon: 'icon-chanpinzhongxin',
          text: '供应商应用',
          children: [{
            text: '独立商城'
          }, {
            text: '数据地图'
          }, {
            text: '价格巡检'
          }, {
            text: '标讯订阅'
          }]
        }
      ]
    };
  },
  created () {
    getFrontCategory().then(res => {
      if (res.success) {
        // let testArr = [
        //   {
        //     current: {
        //       logo: 'logo-1',
        //       name: '1-1'
        //     },
        //     children: [
        //       {
        //         current: {
        //           name: '1-1-1'
        //         }
        //       },{
        //         current: {
        //           name: '1-1-2'
        //         }
        //       },
        //     ]
        //   },{
        //     current: {
        //       logo: 'logo-2',
        //       name: '1-2'
        //     },
        //     children: [
        //       {
        //         current: {
        //           name: '1-2-1'
        //         }
        //       }
        //     ]
        //   },{
        //     current: {
        //       logo: 'logo-3',
        //       name: '1-2'
        //     }
        //   }
        // ]
        this.cateList = mapCate(res.result).slice(0, 7);
      }
    });
  }
};
</script>

<style lang="less">
@import '../../../assets/css/common.less';

.nav-cate-wrapper {
  position: relative;
  .navcate-title {
    height: @nav-height;
    width: @nav-cate-width;
    border-radius: @border-radius-normal @border-radius-normal 0 0;
    background: @color-blue;
    color: @font-color-highlight;
    font: normal 400 @font-size-m @family-nomal;
    span {
      line-height: @nav-height;
    }
    i {
      margin: 0 1em;
    }
  }

  .navcate-title__hover {
    cursor: pointer;
    z-index: 99;
    &:hover {
      ~ div.navcate-content-wrapper {
        .navcate-content;
        border-width: 1px;
      }
    }
  }
  .navcate-content-wrapper {
    position: absolute;
    width: @nav-cate-width;
    height: @nav-cate-content-height;
    padding: 0;
    box-sizing: border-box;
    top: @nav-height;
    left: 0;
    background: #fff;
    z-index: 2;
    display: none;
    // overflow: hidden;
    &:hover {
      .navcate-content;
    }
  }
  .navcate-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border: 1px solid @color-blue;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/nav/nav-cate/index.vue